import { graphql } from "@/graphql/generated/gql";

export const getFocusAreaQueryDocument = graphql(/* GraphQL */ `
  query GetFocusArea($input: GetFocusAreaInput!) {
    focusArea(getFocusAreaInput: $input) {
      ...FocusAreaFields
      instanceList {
        ...FocusAreaInstanceFields
      }
    }
  }
`);

export const getFocusAreaListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetFocusAreaListForWorkspace($input: GetFocusAreaListForWorkspaceInput!) {
    focusAreaListForWorkspace(getFocusAreaListForWorkspaceInput: $input) {
      ...FocusAreaFields
      instanceList {
        ...FocusAreaInstanceFields
      }
    }
  }
`);

export const createFocusAreaMutationDocument = graphql(/* GraphQL */ `
  mutation createFocusArea($input: CreateFocusAreaInput!) {
    createFocusArea(createFocusAreaInput: $input) {
      ...FocusAreaFields
      instanceList {
        ...FocusAreaInstanceFields
      }
    }
  }
`);

export const updateFocusAreaMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateFocusArea($input: UpdateFocusAreaInput!) {
    updateFocusArea(updateFocusAreaInput: $input) {
      ...FocusAreaFields
      instanceList {
        ...FocusAreaInstanceFields
      }
    }
  }
`);

export const reorderFocusAreaMutationDocument = graphql(/* GraphQL */ `
  mutation ReorderFocusArea($input: ReorderFocusAreaInput!) {
    reorderFocusArea(reorderFocusAreaInput: $input) {
      ...FocusAreaFields
    }
  }
`);

export const deleteFocusAreaMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteFocusArea($input: DeleteFocusAreaInput!) {
    deleteFocusArea(deleteFocusAreaInput: $input) {
      ...FocusAreaFields
      instanceList {
        ...FocusAreaInstanceFields
      }
    }
  }
`);
